import { requestJson } from './requestJson';

export async function getAdminStats(): Promise<{
  stats: {
    creators: number;
    tests: number;
    tests_owned: number;
    tests_anonymous: number;
    tests_on_a_timer: number;
    reviewers: number;
    reactions: number;
    samples: number;
    database_bytes: number;
    database_size_pretty: string;
  };
}> {
  return await requestJson('/api/admin/stats');
}
